<!-- ----------------------------------------- template ----------------------------------------- -->
<template>
  <div class="club-d">
    <div class="club-d-operation">
      <div class="operation-header">
        <div class="operation-header-icon" :style="clubAvatarStyle">
          <template v-if="clubInfo.avatar">
            <img :src="clubInfo.avatar" style="width: 100%; height: 100%; border-radius: 50%; background-color: white; border: 1px solid #e0e0e0;" />
          </template>
          <template v-else>
            {{ clubInfo.name ? clubInfo.name.charAt(0).toUpperCase() : '' }}
          </template>
        </div>
        <div class="operation-header-info">
          <div class="operation-header-name">
            {{ clubInfo.name }}
            <span v-if="clubInfo.account_nameEN || clubInfo.account_name" class="school-name">
              @ {{ clubInfo.account_nameEN || clubInfo.account_name }}
            </span>
          </div>
          <div class="club-type-tags">
            <template v-if="Array.isArray(clubInfo.type)">
              <span v-for="(type, index) in clubInfo.type" :key="index" class="operation-header-type">{{ type }} Club</span>
            </template>
            <span v-else class="operation-header-type">{{ clubInfo.type }} Club</span>
          </div>
          <div class="operation-header-intro">{{ clubInfo.intro }}</div>
        </div>
      </div>
      
    </div>
    <div class="club-d-list" style="width: 100%">
      <div class="tab-tags-container">
        <div class="tab-tags-rows">
          <div class="tab-tags tab-tags-row-1">
            <span
              v-for="tab in firstRowTabs"
              :key="tab.name"
              :class="['tab-tag', { 'active': activeTab === tab.name }]"
              @click="activeTab = tab.name"
            >
              {{ tab.label }}
            </span>
          </div>
          <div class="tab-tags tab-tags-row-2">
            <span
              v-for="tab in secondRowTabs"
              :key="tab.name"
              :class="['tab-tag', { 'active': activeTab === tab.name }]"
              @click="activeTab = tab.name"
            >
              {{ tab.label }}
            </span>
          </div>
        </div>

        <div class="tab-content" style="position: relative;">
          <div v-if="tabLoading" class="tab-loading-mask">
            <i class="el-icon-loading"></i>
          </div>
          <div v-show="activeTab === 'Events'" class="tab-pane">
            <Events :clubInfo="clubInfo" :club_id="club_id"/>
          </div>
          <div v-show="activeTab === 'Discussions'" class="tab-pane">
            <Discussions :clubInfo="clubInfo" :club_id="club_id"/>
          </div>
          <div v-show="activeTab === 'Todos'" class="tab-pane">
            <Todos :clubInfo="clubInfo" :club_id="club_id"/>
          </div>
          <div v-show="activeTab === 'Achievements'" class="tab-pane">
            <Achievements :clubInfo="clubInfo" :club_id="club_id"/>
          </div>
          <div v-show="activeTab === 'Honors'" class="tab-pane">
            <Honors :clubInfo="clubInfo" :club_id="club_id"/>
          </div>
          <div v-show="activeTab === 'leadership'" class="tab-pane">
            <Leadership :clubInfo="clubInfo" :club_id="club_id" />
          </div>
          <div v-show="activeTab === 'advisers'" class="tab-pane">
            <Advisers :clubInfo="clubInfo" :club_id="club_id" />
          </div>
          <div v-show="activeTab === 'members'" class="tab-pane">
            <ClubStudents
              :club_id="club_id"
              :clubInfo="clubInfo"
              :activeTab="activeTab"
              @change-tab="handleTabChange"
              @refresh-club="requestClubInfo"
            />
          </div>
          <div v-show="activeTab === 'Documents'" class="tab-pane">
            <Documents :clubInfo="clubInfo" :club_id="club_id"/>
          </div>
          <div v-show="activeTab === 'Profile'" class="tab-pane">
            <Profile :clubInfo="clubInfo" :club_id="club_id" @club-updated="fetchClubInfo"/>
          </div>
          <div v-show="activeTab === 'Settings'" class="tab-pane">
            <Settings :clubInfo="clubInfo" :club_id="club_id"/>
          </div>
          <div v-show="activeTab === 'Statistics'" class="tab-pane">
            <Statistics :clubInfo="clubInfo" :club_id="club_id"/>
          </div>
          <div v-show="activeTab === 'ContentOrders'" class="tab-pane">
            <ContentOrders :clubInfo="clubInfo" :club_id="club_id" scene="club"/>
          </div>
          <div v-show="activeTab === 'Applications'" class="tab-pane">
            <Applications :club_id="club_id" @change-tab="handleTabChange"/>
          </div>
          <div v-show="activeTab === 'Membership'" class="tab-pane">
            <Membership :club_id="club_id"/>
          </div>
        </div>
      </div>
    </div>
    
  </div>
</template>

<!-- ------------------------------------------ script ------------------------------------------ -->
<script>
import {
  getClubInfo,
  postRequest
} from "@/api/eclub";

import { getUserId, getUserType } from '@/utils/store';
import Discussions from './components/Discussions.vue'
import Todos from './components/Todos.vue'
import Members from './components/Members.vue'
import Documents from './components/Documents.vue'
import Profile from './components/Profile.vue'
import DEditor from './components/DEditor/index.vue'
import Events from './components/Events.vue'
import Achievements from './components/Achievements.vue'
import Honors from './components/Honors.vue'
import Settings from './components/Settings.vue'
import Leadership from './components/Leadership.vue'
import ClubStudents from '../ClubStudents/index.vue'
import Statistics from './components/Statistics.vue'
import ContentOrders from '@/views/ContentOrders/index.vue'
import Applications from './components/Applications.vue'
import Membership from './components/Membership.vue'
import Advisers from './components/Advisers.vue'

export default {
  name: 'ClubDetail',
  components: {
    Discussions,
    Todos,
    Members,
    Documents,
    Profile,
    DEditor,
    Events,
    Achievements,
    Honors,
    Settings,
    Leadership,
    ClubStudents,
    Statistics,
    ContentOrders,
    Applications,
    Membership,
    Advisers
  },

  data () {
    return {
      club_id: this.$route.query.club_id,
      activeTab: 'Events',
      clubInfo: {},
      userType: getUserType(),
      operationPage: 'editor', // editor
      tabLoading: false
    }
  },

  /* 一.生命周期函数 */
  created () {
    this.requestClubInfo();
  },

  /* 二.监控函数 */
  watch: {
    activeTab() {
      this.requestClubInfo();
    }
  },

  computed: {
    firstRowTabs() {
      const userType = this.getUserType()
      const tabs = [
        { label: 'Events', name: 'Events' },
        { label: 'Posts', name: 'Discussions' },
        { label: 'Todos', name: 'Todos' },
        { label: 'Leadership', name: 'leadership' },
        { label: 'Advisers', name: 'advisers' },
        { label: 'Club Members', name: 'members' },
        { label: 'Documents', name: 'Documents' },
        { label: 'Profile', name: 'Profile' },
        { label: 'Statistics', name: 'Statistics' }
      ]

      // Add conditional tabs based on user type
      if (['schoolAdmin', 'adviser'].includes(userType)) {
        tabs.push({ label: 'Settings', name: 'Settings' })
      }

      if (userType === 'student') {
        tabs.push({ label: 'Membership', name: 'Membership' })
      }

      return tabs
    },

    secondRowTabs() {
      const userType = this.getUserType()
      const tabs = [
        { label: 'Internal Achievements', name: 'Achievements' },
        { label: 'External Honors', name: 'Honors' }
      ]

      // Add Content Orders if user is admin or advisor
      if (['schoolAdmin', 'advisor'].includes(userType)) {
        tabs.push({ label: 'Content Orders', name: 'ContentOrders' })
      }

      return tabs
    }
  },

  /* 三.内部功能函数 */
  methods: {
    /* ----------------------事件调用函数------------------------ */
    // 事件调用函数注释
    actionTabClick (tab) {
      console.log(typeof tab.index, tab.index, tab.name) // string 1 Todos
    },

    ajaxQuit() {
      // TODO: Implement quit functionality
      this.$message.warning('Coming soon~');
    },

    /* ----------------------内部功能函数------------------------ */
    // 内部功能函数注释
    doSomething () {

    },

    /* ----------------------服务请求函数------------------------ */
    // 服务请求函数注释
    requestClubInfo() {
      this.tabLoading = true;
      postRequest('getClubInfo', {
        club_id: this.club_id,
        user_id: getUserId()
      }).then((res) => {
        this.clubInfo = res.data.data;
      }).finally(() => {
        this.tabLoading = false;
      });
    },

    getUserType() {
      return getUserType()
    },

    async fetchClubInfo() {
      // Call the existing requestClubInfo method to refresh club data
      await this.requestClubInfo()
    },

    handleTabChange(tabName) {
      this.activeTab = tabName
    }
  }
}
</script>

<!-- ------------------------------------------ style ------------------------------------------ -->
<style scoped lang="scss">
.club-d{
  height: 100%;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  
  &-list{
    flex: 1;
    overflow: hidden;
    padding: 5px 20px;
    width: 100%;

    .tab-tags-container {
      width: 100%;
      height: 100%;
      display: flex;
      flex-direction: column;

      .tab-tags-rows {
        border-bottom: 1px solid #e4e7ed;
        margin-bottom: 16px;
      }

      .tab-tags {
        display: flex;
        flex-wrap: wrap;
        gap: 8px;
        padding: 8px 0;

        &.tab-tags-row-1 {
          padding-top: 12px;
        }

        &.tab-tags-row-2 {
          padding-bottom: 12px;
        }

        .tab-tag {
          padding: 8px 16px;
          background-color: #f5f7fa;
          color: #606266;
          border-radius: 4px;
          font-size: 14px;
          cursor: pointer;
          transition: all 0.3s;
          user-select: none;
          border: 1px solid #e4e7ed;

          &:hover {
            background-color: #ecf5ff;
            color: #409eff;
            border-color: #c6e2ff;
          }

          &.active {
            background-color: #409eff;
            color: white;
            border-color: #409eff;
          }
        }
      }

      .tab-content {
        flex: 1;
        overflow-y: auto;
        position: relative;

        .tab-loading-mask {
          position: absolute;
          top: 0;
          left: 0;
          right: 0;
          bottom: 0;
          background: rgba(255, 255, 255, 0.7);
          z-index: 100;
          display: flex;
          align-items: center;
          justify-content: center;

          i {
            font-size: 32px;
            color: #409eff;
          }
        }

        .tab-pane {
          width: 100%;
          height: 100%;
          overflow-y: auto;
        }
      }
    }
  }
  &-operation{
    padding: 20px 20px 5px 0;
    margin-left: 12px;
    height: auto;
    overflow: visible;
    .operation{
      &-header{
        display: flex;
        align-items: center;
        justify-content: flex-start;
        margin-bottom: 16px;
        &-icon{
          width: 64px;
          height: 64px;
          border-radius: 50%;
          background-color: #e6e6e6;
          display: flex;
          align-items: center;
          justify-content: center;
          font-size: 32px;
          font-weight: bold;
          color: #666;
        }
        &-info {
          flex: 1;
          margin-left: 12px;
        }
        &-name{
          margin-right: 12px;
          font-size: 24px;
          font-weight: bold;
          display: flex;
          align-items: baseline;
          gap: 8px;

          .school-name {
            font-size: 16px;
            color: #999;
            font-weight: normal;
            font-style: italic;
          }
        }

        .club-type-tags {
          margin-top: 6px;
          display: flex;
          flex-wrap: wrap;
          gap: 6px;

          .operation-header-type {
            display: inline-block;
            font-size: 12px;
            color: #666;
            font-weight: normal;
            padding: 2px 8px;
            border-radius: 12px;
            background-color: #f5f5f5;
            border: 1px solid #e0e0e0;
            line-height: 1.4;
          }
        }
        &-intro {
          font-size: 14px;
          color: #666;
          line-height: 1.4;
        }
      }
    }
  }
}
</style>
